import { SalesOrderDetailSlidein } from '@/components/accounts-receivable/sales-order-detail/sales-order-detail-slidein';
import { useNavigate, useParams } from '@tanstack/react-router';

export function Route() {
  const { salesOrderId } = useParams({
    from: '/authenticated/accounts-receivable/ingested-sales-orders/$salesOrderId',
  });
  const navigate = useNavigate();

  return (
    <SalesOrderDetailSlidein
      salesOrderId={salesOrderId}
      isOpen
      onOpenChange={() => {
        navigate({
          to: '..',
          search: true,
          viewTransition: true,
        });
      }}
    />
  );
}
